export function formatDateUniversal(inputDate: string): string {
    const dateObject = new Date(inputDate.split('T')[0]);
  
    if (isNaN(dateObject.getTime())) {
      throw new Error("Invalid date format. Please provide a valid ISO or MM/DD/YYYY date.");
    }
  
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, '0');
    const day = String(dateObject.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }
  
  